import { fixOverspends } from './fixOverspends'

export const overspendModel = { fixAll: fixOverspends }
